"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCollapseContext = exports.CollapseProvider = void 0;
var _presentationHooks = require("@ori/presentation-hooks");
var _react = _interopRequireWildcard(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const CollapseContext = /*#__PURE__*/(0, _react.createContext)({
  open: false,
  onOpen: () => {},
  onClose: () => {},
  onToggle: () => {}
});

/**
 * Material UI Collapse context provider
 *
 * @param children
 * @constructor
 */
const CollapseProvider = ({
  children
}) => {
  const value = (0, _presentationHooks.useDisclose)();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(CollapseContext.Provider, {
    value: value,
    children: children
  });
};
exports.CollapseProvider = CollapseProvider;
const useCollapseContext = () => (0, _react.useContext)(CollapseContext);
exports.useCollapseContext = useCollapseContext;
